import { InjectionToken } from "@angular/core";
import { ICurrentUserResolver } from "./i-current-user.resolver";

export const currentUserResolverInjectionToken: InjectionToken<ICurrentUserResolver> = new InjectionToken<ICurrentUserResolver>("digital-signage.user-dashboard.dashboard-web.CurrentUserResolver");
